var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPolygonIcon = function SvgPolygonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.540708 6.53867L10 1.07735L19.4593 6.53867V17.4613L10 22.9227L0.540708 17.4613V6.53867Z",
    stroke: "#D1D1D1"
  })));
};
export { SvgPolygonIcon as ReactComponent };
export default __webpack_public_path__ + "assets/a811b88b.svg";